module.exports = __webpack_public_path__ + "site/img/indexsd2en.1c0e5c26.jpg";